import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import TextInput from "../../widgets/TextInput";
import FixButton from "../../widgets/Button";
import addAula from "../../services/addAula";
import TextNumberInput from "../../widgets/TextNumberInput";
import translateString from "../../utils/Locales";
import Utils from "../../utils/utils";

let t = translateString;

export default class AddAula extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false,
      nomeAula: '', 
      capienzaAula: 0,
    }

    this.grid = 2;
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = {
        capienzaAula: 0
    };

  }


  async componentDidMount(){

    const cookies = new Cookies();
    this.dbPath = cookies.get('db_path', { path: '/' });
    Utils.setAnalyticsPage('Classroom creation - ' + cookies.get('db', { path: '/' }));

    this.setState({});
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: () => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('aggiungi_aula')} />
          <TextInput name={t('nome_aula')} style={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey' }} value={this.state.nomeAula} 
            onChange={(text) => { this.setState({nomeAula: text})}
          } />
           <TextNumberInput name={t('capienza_aula')} inputStyle={{ borderLeft: 0, borderTop: 0, borderRight: 0, borderBottom: '1px solid darkgrey' }} value={this.state.capienzaAula} 
            onChange={(text) => { this.setState({capienzaAula: text})}
          } />
          <br/>
          <FixButton title={t('salva')} callback={this.save.bind(this)} />

        </LoadingOverlay>
      </>
    );
  }

  async save () {

      if (this.state.nomeAula !== '' && this.state.capienzaAula !== 0) {
          const cookies = new Cookies();
          const username = cookies.get('username', { path: '/' });
          const token = cookies.get('token', { path: '/' });

          let ret = await addAula (username, token, this.state.nomeAula, this.state.capienzaAula);

          if (ret.result == 'ok'){
            window.location.href =  '/' + this.dbPath + '/#/app/aule';
          }
          else {
            Utils.showError(t('errore_imprevisto'));
          }
      } else {
        Utils.showError(t('verifica_dati'));
      }
  }

}

